// extracted by mini-css-extract-plugin
export default {"menu":"MenuGroup_menu__pkVHO","list":"MenuGroup_list__hMoI3","item-icon":"MenuGroup_item-icon__TIPSz","item-text":"MenuGroup_item-text__Kuq6i","active":"MenuGroup_active__qXID1"};